export default __webpack_public_path__ + "static/media/Q0004.ce861fcd.png";